<template>
  <div>
    <base-button
      class="tw-uppercase"
      secondary
      full-width
      :sr-only="$t('report')"
      @click="triggerReportModal"
    >
      {{ $t('report') }}
    </base-button>
  </div>
</template>

<script>
import { setGlobalModal } from '@composables/useModal.js'
import { MODAL_REPORT } from '@config/globalModals.js'
import { RESOURCE_OPTIONS } from '@config/options.js'
export default {
  props: {
    resourceId: {
      type: Number,
      default: null,
    },
    resource: {
      type: String,
      required: true,
      validator(value) {
        return Object.keys(RESOURCE_OPTIONS).includes(value)
      },
    },
    name: {
      type: String,
      default: '',
    },
  },
  setup(props) {
    function triggerReportModal() {
      setGlobalModal({
        modal: MODAL_REPORT,
        data: {
          resource: props.resource,
          resourceId: props.resourceId,
        },
      })
    }

    return { triggerReportModal }
  },
}
</script>
